import get from 'lodash/get';

export default function selector(storeState) {
    const audienceSegments = get(storeState, 'seasonalDashboard.audienceSegments');
    const totalSegmentCount = get(storeState, 'seasonalDashboard.totalSegmentCount');
    const isLoading = get(storeState, 'seasonalDashboard.isLoading');
    const organizationId = get(storeState, 'profile.organizationId');

    return {
        audienceSegments,
        totalSegmentCount,
        isLoading,
        organizationId,
    };
}
